
import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { useAuth } from '@/hooks/useAuth';
import { useImageUrl } from '@/hooks/useImageUrl';

export const UserProfileInfo = () => {
  const { user, profileData } = useAuth();

  const displayName = profileData?.username || user?.email?.split('@')[0] || 'Usuário';
  
  // Use async hook for v1.5 signed URL support
  const { url: avatarPhoto } = useImageUrl(
    profileData?.main_photo_url,
    'avatar'
  );
    
  const userLocation = profileData?.city && profileData?.state_code
    ? `${profileData.city}, ${profileData.state_code}` 
    : (profileData?.city || '');

  return (
    <div className="flex items-center md:gap-2 md:p-2 lg:gap-3 lg:p-3">
      <Avatar className="md:h-8 md:w-8 lg:h-10 lg:w-10">
        <AvatarImage 
          src={avatarPhoto}
          alt={displayName}
        />
        <AvatarFallback className="bg-luxury-red text-white">
          {displayName[0]?.toUpperCase()}
        </AvatarFallback>
      </Avatar>
      
      <div className="flex flex-col min-w-0 flex-1">
        <span className="text-white font-medium md:text-xs lg:text-sm truncate">
          {displayName}
        </span>
        <span className="text-white/60 md:text-[10px] lg:text-xs truncate">
          {userLocation || user?.email}
        </span>
      </div>
    </div>
  );
};

export default UserProfileInfo;
